<div [class]="theme ? theme : 'one-portal'">
  <div class="">
    <p>
      Please confirm porcessing of the order. The order will be processed immediately
    </p>
    <p>Once confirmed, you will not be able to stop the order from processing.</p>
  </div>
  <div class="button-container btn-group">
    <button mat-button class="btn btn-secondary" (click)="closeDialog(false)">Cancel</button>
    <button mat-button class="btn btn-primary" type="submit" (click)="closeDialog(true)">
      Confirm
    </button>
  </div>
</div>
